<div class="FormTemplate">
    <div id="MainTab" class="tab-content">
        <form [formGroup]="PANForm">
            <div class="row">
                <div class="col-md-2 col-sm-4 col-xs-6 InputBoxOuter">
                    <div class="has-float-label">
                        <input type="text" id="FullName" maxlength="10"
                            class="form-control CommonTextBox TbxMarginBtm text-uppercase" placeholder="&nbsp;"
                            autocomplete="off" formControlName="PANNO" (input)="onPANChange()"
                            aria-autocomplete="none" />
                        <label for="FullName">PAN No</label>
                        <div *ngIf="getform.PANNO.errors && submitPAN" class="text-danger">
                            <div *ngIf="getform.PANNO.errors.required">Pan is required.</div>
                        </div>
                        <div *ngIf="!IsPANValid" class="text-danger">Please enter valid PAN number.</div>
                    </div>
                    <div class="text-success fw-bold">
                        <b>{{ClientName}}</b>
                    </div>
                </div>
                <div class="col-md-2 col-sm-2 col-xs-6 mx-3 InputBoxOuter" *ngIf="showNotPanOnly">
                    <div>
                        <label for="PoliticalExposure">Select User Type</label>
                        <div class="d-flex">
                            <span class="mr-4">
                                <div class="CheckAgree">
                                    <label class="Cbx_container RadioBtn">
                                        <input type="radio" id='PoliY' class=" flterradio" name="changetype"
                                            formControlName="UserType" value="broker" checked />
                                        <span class="checkmark"></span>
                                        <label for='PoliY'>Subbroker</label>
                                    </label>
                                </div>
                            </span>
                            <span>
                                <div class="CheckAgree">
                                    <label class="Cbx_container RadioBtn">
                                        <input type="radio" id='PoliN' class=" flterradio" name="changetype"
                                            formControlName="UserType" value="emp" />
                                        <span class="checkmark"></span>
                                        <label for='PoliN'>Employee</label>
                                    </label>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12 InputBoxOuter" *ngIf="showNotPanOnly">
                    <div class="has-float-label">
                        <input type="text" id="UserIDFullName" maxlength="10"
                            class="form-control CommonTextBox TbxMarginBtm text-uppercase" placeholder="&nbsp;"
                            autocomplete="off" formControlName="UserID" aria-autocomplete="none" />
                        <label for="UserIDFullName">Employee Code / Subbroker Code</label>
                        <div *ngIf="getform.UserID.errors && submitPAN" class="text-danger">
                            <div *ngIf="getform.UserID.errors.required">User ID is required.</div>
                        </div>
                    </div>
                    <div class="text-success fw-bold">
                        <b>{{UserName}}</b>
                    </div>
                </div>
                <div class="col-md-2 col-sm-4 col-xs-6 InputBoxOuter" *ngIf="showNotPanOnly">
                    <button class="CommonSubmitButton mx-2" (click)="onSubmit()">Search</button>
                </div>
            </div>
        </form>
    </div>
</div>